<template>
    <div class="login-box well white-box">
        <logo-component></logo-component>
        <div class="alert alert-danger" v-if="error">
            <p>{{ error_message }}</p>
        </div>
        <div class="alert alert-success" v-if="success">
            <p>Password changed correctly, now you can <router-link :to="{name : 'login'}">login</router-link> with your new password.</p>
        </div>
        <b-form @submit.prevent="onSubmit" v-else>
            <b-form-group
                    label="New password:"
                    label-for="password">
                <b-form-input
                        name="password"
                        id="password"
                        v-model="password"
                        type="password"
                        v-validate="{ required:true }"
                        :state="errors.has('password') ? false : null">
                </b-form-input>
                <em v-if="errors.has('password')" class="text-danger">
                    {{ errors.first('password') }}
                </em>
            </b-form-group>
            <b-form-group
                    label="Repeat password:"
                    label-for="password_confirmation">
                <b-form-input
                        name="password_confirmation"
                        id="password_confirmation"
                        v-model="password_confirmation"
                        type="password"
                        v-validate="{ required:true }"
                        :state="errors.has('password_confirmation') ? false : null">
                </b-form-input>
                <em v-if="errors.has('password_confirmation')" class="text-danger">
                    {{ errors.first('password_confirmation') }}
                </em>
            </b-form-group>
            <b-button type="submit" variant="primary">Reset Password</b-button>
        </b-form>
    </div>
</template>

<script>
    import LogoComponent from './Logo.vue';
    export default {
        name: "RecoverPassword",
        components: {
            LogoComponent
        },
        props: ['token'],
        $_veeValidate: {
            validator: 'new'
        },
        created() {
            axios.get('/users/password/verify/' + this.token)
            .then(function (response) {
            })
            .catch((error) => {
                this.error = true;
                this.error_message = error.response.data.message;
            })
        },
        data() {
            return {
                password: '',
                password_confirmation: '',
                error: '',
                error_message: '',
                success: '',
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        axios.put('/users/password/reset', {
                            "token": this.token,
                            "password": this.password,
                            "password_confirmation": this.password_confirmation,
                        })
                        .then(() => {
                            this.success = true;
                            this.error = false;
                        })
                        .catch((error) => {
                            this.error = true;
                            this.error_message = error.response.data.message;
                        })
                    }
                });
            },
        },
        mounted() {
            $('html').addClass('login');
        },
    }
</script>

<style scoped>

</style>